import { useSelector } from "react-redux";
import { get } from "lodash";

import {
  REQUEST_MASTER_FAQ,
  REQUEST_CREATE_MASTER_FAQ,
  REQUEST_UPDATE_MASTER_FAQ,
  REQUEST_DELETE_MASTER_FAQ,
  SET_MASTER_FAQ,
  SUCCESS_CREATE_MASTER_FAQ,
  SUCCESS_UPDATE_MASTER_FAQ,
  SUCCESS_DELETE_MASTER_FAQ,
  ERROR_GET_MASTER_FAQ,
  ERROR_CREATE_MASTER_FAQ,
  ERROR_UPDATE_MASTER_FAQ,
  ERROR_DELETE_MASTER_FAQ,
  SET_MESSAGE_MASTER_FAQ,
} from "./faqActionTypes";
import { IFaq } from "../../types/faq";

interface IState {
  busy: boolean;
  message: string;
  masterFaqs: IFaq[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterFaqs: [],
};

const faqss = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_FAQ:
    case REQUEST_CREATE_MASTER_FAQ:
    case REQUEST_UPDATE_MASTER_FAQ:
    case REQUEST_DELETE_MASTER_FAQ:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_FAQ:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_FAQ:
      return {
        ...state,
        busy: false,
        message: "",
        masterFaqs: action.payload,
      };

    case SUCCESS_CREATE_MASTER_FAQ:
      return {
        ...state,
        busy: false,
        message: "",
        masterFaqs: [...state.masterFaqs, action.payload],
      };

    case SUCCESS_DELETE_MASTER_FAQ:
      return {
        ...state,
        busy: false,
        message: "",
        masterFaqs: state.masterFaqs.filter(
          (faqs) => get(faqs, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_FAQ:
      return {
        ...state,
        busy: false,
        message: "",
        masterFaqs: state.masterFaqs.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_FAQ:
    case ERROR_CREATE_MASTER_FAQ:
    case ERROR_UPDATE_MASTER_FAQ:
    case ERROR_DELETE_MASTER_FAQ:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default faqss;

export function useFaqsMaster() {
  return useSelector((state: Record<string, any>) => state.faqs);
}
